import { useState } from 'react';
import API_BASE_URL from '../config/api';

const useAiTranslation = () => {
    const [response, setResponse] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const getResponse = async (prompt, type = 'translation') => {
        setIsLoading(true);
        setError(null);
        
        try {
            const res = await fetch(`${API_BASE_URL}/api/ai/translate`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({ prompt, type })
            });

            if (!res.ok) {
                const errorData = await res.json();
                throw new Error(errorData.error || 'Übersetzung fehlgeschlagen');
            }

            const data = await res.json();
            const responseContent = data.content;
            setResponse(responseContent);
            return responseContent;
        } catch (err) {
            console.error('Error fetching translation:', err);
            setError(err.message);
            return null;
        } finally {
            setIsLoading(false);
        }
    };

    return { response, getResponse, isLoading, error };
};

export default useAiTranslation;
